import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, domain, NumberFormatter, i18n, DateFormatter, isAuth } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';

import SwitchButtonV4 from '../shared/switchButtonV4.jsx'
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import { isNullOrUndefined } from 'util';
import ApplicationData from '../../app/aApplicationData'
import { resolve } from 'path';


class ProdottoDocumentPrint extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ProdottoDocumentPrint.jsx] ';
        this.state = {
            showConfirm: false,
            showConfirmDelete: false,
            prodottoDaEliminare: null,
            validation: new Map(),
            showConfirmModifica: false,
            document: {},
            ordersList: [],
            tipoOperazioneList: [],
            questionariSelezionabili: []
        }
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.deleteProdottoDocument = this.deleteProdottoDocument.bind(this);
        this.showConfirmDelete = this.showConfirmDelete.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.salvaDocumentPrint = this.salvaDocumentPrint.bind(this);
        this.inizilizzaNuovoDocPrint = this.inizilizzaNuovoDocPrint.bind(this);
        this.aggiornaListaTipoOperazione = this.aggiornaListaTipoOperazione.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [];
        if (isAuth('V2.ADMIN.PRODUCT.TAB_DOC_IN.VIEW.TIPO_OPERAZIONE')) {
            columns = [
                { field: 'ordVis', title: i18n('ARM_CORE_PRODUCT.MANAGE.ORDINE', '#'), align: "center", sortable: 'true' },
                { field: 'idProdottoDocument', title: 'Id', sortable: 'true' },
                { field: 'documento', title: i18n('ARM_CORE_PRODUCT.SHARED.NOME', 'Nome'), align: "center", sortable: 'true', formatter: this.docCategoryFormatter },
                { field: 'operazione', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO.TIPO_OPERAZIONE', 'Tipo operazione'), align: "center", sortable: 'true' },
                { field: 'dateUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_UPDATE', 'Data Modifica'), align: "center", sortable: 'true', formatter: this.dateFormatter },
                { field: 'idUserUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.CREATO_DA', 'Modificato da'), align: "center", sortable: 'true' },
                { field: 'download', title: i18n('ARM_CORE_PRODUCT.SHARED.DOWNLOAD', 'Scarica'), align: "center", formatter: this.columnDownload },
                { field: 'edit', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.MODIFICA", "Modifica"), formatter: this.columnEdit },
                { field: 'elimina', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.ELIMINA", "Elimina"), formatter: this.columnDelete },
            ];
        } else {
            columns = [
                { field: 'ordVis', title: i18n('ARM_CORE_PRODUCT.MANAGE.ORDINE', '#'), align: "center", sortable: 'true' },
                { field: 'idProdottoDocument', title: 'Id', sortable: 'true' },
                { field: 'documento', title: i18n('ARM_CORE_PRODUCT.SHARED.NOME', 'Nome'), align: "center", sortable: 'true', formatter: this.docCategoryFormatter },

                { field: 'dateUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_UPDATE', 'Data Modifica'), align: "center", sortable: 'true', formatter: this.dateFormatter },
                { field: 'idUserUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.CREATO_DA', 'Modificato da'), align: "center", sortable: 'true' },
                { field: 'download', title: i18n('ARM_CORE_PRODUCT.SHARED.DOWNLOAD', 'Scarica'), align: "center", formatter: this.columnDownload },
                { field: 'edit', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.MODIFICA", "Modifica"), formatter: this.columnEdit },
                { field: 'elimina', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.ELIMINA", "Elimina"), formatter: this.columnDelete },
            ];
        }

        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "idProdottoDocument",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.downloadOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        // repuro tutti i documenti da print
        this.props.getAiPrintDocumenti();

    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== undefined && nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));
            let ordersList = [];
            if (nextProps.rows === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
                nextProps.rows.forEach((element, index) => {
                    ordersList.push({ value: index + 1 });
                });
            }
            this.setState({ ordersList: ordersList })
        }
    }

    downloadOnClick(row, $element, field) {
        console.log(this.componentName + " showConfirmPanel()");

        if (field === "download") {
            this.props.downloadDocument(row.idPrintTemplate);
        } else if (field === "elimina") {
            this.inzializzaEliminaDocument(row.idProdottoDocument);
        } else if (field === "edit") {
            this.props.inizilizzaModificaDocPrint(row)
            this.aggiornaListaTipoOperazione();
            this.inizializzaListaQuestionarioSelezionabili(this.props.document.operazione)
            this.showConfirmPanel()

        }
    }

    salvaDocumentPrint() {

        let validation = new Map();

        let required = ["idAiPrintDocument", "ordVis"];

        for (let i = 0; i < required.length; i++) {
            if (this.props.document[required[i]] === undefined || this.props.document[required[i]] === null || this.props.document[required[i]] === ''
                || this.props.document[required[i]].toString().trim() === '') {

                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }

        this.setState({ validation: validation })
        if (validation.size == 0) {
            this.props.salvaDocumentPrint();
        }
    }

    inputChangeHandler(e) {

        let id = e.target.id;
        let value = e.target.value;

        let validation = this.state.validation;
        if (validation.has(id)) {
            validation.delete(id);

            this.setState({ validation: validation })
        }
        if (id === "operazione" && value && value !== "") {
            this.inizializzaListaQuestionarioSelezionabili(value);
        }

        this.props.inputChangeHandler(e);

    }

    inizializzaListaQuestionarioSelezionabili(operazione) {
        let listProdottoOperazione = this.props.prodotto.listProdottoOperazione;
        if (listProdottoOperazione && operazione) {
            let operazioneObj = listProdottoOperazione.find(ope => ope.opeTipoOperazione === operazione)
            if (operazioneObj && operazioneObj.codQuestionarioCliente && operazioneObj.codQuestionarioCliente !== "") {

                let questionariSelezionabiliSplitted = operazioneObj.codQuestionarioCliente.split(";");
                let questionariSelezionabili = [];

                questionariSelezionabiliSplitted.forEach(element => {
                    questionariSelezionabili.push({ valore: element })

                });
                this.setState({ questionariSelezionabili: questionariSelezionabili })
            }
        }
    }
   
     inizilizzaNuovoDocPrint() {
        let ordersList = [];
        let nextOrder = 10;
        
        this.props.rows.forEach((element, index) => {
            ordersList.push({ value: nextOrder });
            if(!isNullOrUndefined(element.ordVis) && element.ordVis % 10 == 0){
            nextOrder += 10; // Increment nextOrder by 10
            }
        });
        ordersList.push({ value: nextOrder });
        this.props.inizilizzaNuovoDocPrint(nextOrder)
        // .then(
        //     resolve => {
        // this.setState({ ordersList: ordersList })
        //     }
        // )
        this.aggiornaListaTipoOperazione();

        this.setState({
            validation: new Map(),
            ordersList: ordersList
        })
    }


    

    /**
     * Metodo per aggiornare la lista di tipo operazione 
     * La lista viene aggiornata/filtrata solo con quelli presenti/selezionati nel prodotto
     */
    aggiornaListaTipoOperazione() {
        let tipoOperazioneList = [];
        let prodottoDetail = this.props.prodotto;
        if (!isNullOrUndefined(prodottoDetail)) {
            let listProdottoOperazione = prodottoDetail.listProdottoOperazione;
            if (!isNullOrUndefined(listProdottoOperazione) && listProdottoOperazione.length > 0) {
                let tempListaDominiDocumenti = domain("AI_TIPO_OPERAZIONE");
                if (!isNullOrUndefined(tempListaDominiDocumenti)) {
                    tempListaDominiDocumenti.forEach((currElement) => {
                        if (!isNullOrUndefined(currElement)) {
                            listProdottoOperazione.forEach((currProdOperazione) => {
                                if (!isNullOrUndefined(currProdOperazione)) {
                                    if (currElement.valCampo != null && currProdOperazione.opeTipoOperazione != null && currElement.valCampo == currProdOperazione.opeTipoOperazione) {
                                        tipoOperazioneList.push(currElement);
                                    }
                                }
                            });
                        }
                    });
                }
            }else{
                let tempListaDominiDocumenti = domain("AI_TIPO_OPERAZIONE");
                if (!isNullOrUndefined(tempListaDominiDocumenti)) {
                    tempListaDominiDocumenti.forEach((currElement) => {
                        if (!isNullOrUndefined(currElement)) {
                            tipoOperazioneList.push(currElement);
                        }
                    });
                }
            }
        }

        this.setState({
            tipoOperazioneList: tipoOperazioneList
        })
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    booleanFormatter(value, row, index) {
        if (value === true || value === "true") {
            return i18n('ARM_CORE_PRODUCT.SHARED.SI', 'Si')
        }
        return i18n('ARM_CORE_PRODUCT.SHARED.NO', 'No')
    }

    docCategoryFormatter(value, row, index) {
        console.log("docCategoryFormatter:" + index);
        if (!isNullOrUndefined(value)) {
            return ApplicationData.domainVal('AI_DOCUMENT_CATEGORY', value, value).desDom;
        }
        return "-";

    }

    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }

    showConfirmPanel() {
        console.log(this.componentName + " showConfirmPanel()");

        this.setState({ showConfirm: !this.state.showConfirm })

    }

    columnDownload(value, row, index) {
        console.log("columnDownload:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-download'></i></button>";
        return temp;
    }

    inzializzaEliminaDocument(idProdottoDocument) {

        this.setState({ prodottoDaEliminare: idProdottoDocument, showConfirmDelete: true });

    }

    columnDelete(value, row, index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

    showConfirmDelete() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
    }

    deleteProdottoDocument() {

        this.showConfirmDelete();

        this.props.deleteProdottoDocumentPrint(this.state.prodottoDaEliminare).then(

            resolve => {
                this.props.getDocumentiProdottoPrint(this.props.idProdotto)
            }
        )
    }

    columnEdit(value, row, index) {
        console.log(this.componentName + " columnEdit: " + index);
        let temp;
        temp = "<button class='btn btn-primary btn-sm'><i class='fas fa-edit fa-fw' data-toggle='tooltip' data-placement='top' title='Modifica'/></button>";
        return temp;
    }

    render() {
        console.log(this.componentName + ' render');
        let random = Math.random();
        return (

            <div className="mt-3">
                <div className="card-header">
                    <agui.aButton bs="primary" className="float-right" icon="fas fa-plus" onClick={this.inizilizzaNuovoDocPrint}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'Nuovo')}</agui.aButton>
                    {/* <h3>{i18n('ARM_CORE_PRODUCT.PRODOTTO.DOC_UPLOAD', 'Documenti da caricare')} </h3> */}

                </div>
                <table ref="MyTable" className={AppConstants.CLASS_TABLE} />

                <agui.ConfirmModalOkCancelV4 show={this.props.showConfirm} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle={i18n('ARM_CORE_PRODUCT.PRODOTTO.NUOVO_DOCUMENTO', 'Nuovo Documento')} onClose={this.props.showConfirmPanel} />
                    <agui.ConfirmModalOkCancelV4.Body testoBody="">
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ASelectV4
                                    id="idAiPrintDocument"
                                    disabled={false}
                                    onChange={this.inputChangeHandler}
                                    validation={this.state.validation}
                                    value={this.props.document ? this.props.document.idAiPrintDocument : null}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.DOCUMENTO', 'Documento')}
                                    items={this.props.listAiPrintDocumenti} 
                                    valueKey="id"
                                    labelKey="alias"
                                />
                            </div>
                        </div>
                        {/* {isAuth('V2.ADMIN.PRODUCT.TAB_DOC_OUT.VIEW.TIPO_OPERAZIONE') && */}
                        <div className="row mt-1">
                            <div className="col col-sm-9 col-md-9 col-lg-9">
                                <agui.ASelectV4
                                    id="operazione"
                                    onChange={this.inputChangeHandler}
                                    value={this.props.document ? this.props.document.operazione : null}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO.TIPO_OPERAZIONE', 'Tipo operazione')}
                                    items={this.state.tipoOperazioneList}
                                    valueKey="valCampo"
                                    labelKey="desDom"
                                    validation={this.state.validation}
                                />
                            </div>
                            <div className="col col-sm-3 col-md-3 col-lg-3">
                                <div key={"divInputRadioFIS" + random} className="customDomanda">
                                    <label key={"labelInputRadioFIS" + random} className="custom-control custom-radio">
                                        <input type="radio"
                                            key={"inputRadio" + random}
                                            className={"form-check-input custom-control-input "}
                                            name="gridRadios"
                                            id={"radioFIS"}
                                            autocomplete="off"
                                            autoComplete="off"
                                            checked={this.props.document.tipoContraente === "FIS"}
                                            onChange={(value) => this.inputChangeHandler({
                                                target: {
                                                    value: "FIS",
                                                    id: "tipoContraente",
                                                }
                                            })} />
                                        <span key={"span1FIS1"} className="custom-control-indicator"></span>
                                        <span key={"span2GIU1"} className="custom-control-description">{i18n('ARM_CORE_PRODUCT.ANAGRAFICA.FIS', 'Fisica')} </span>
                                    </label>
                                </div>
                                <div key={"divInputRadioGIU" + random} className=" customDomanda">
                                    <label key={"labelInputRadioGIU" + random} className="custom-control custom-radio">
                                        <input type="radio"
                                            key={"inputRadio2 " + random}
                                            className={"form-check-input custom-control-input "}
                                            name="gridRadiosGIU"
                                            id={"radioGIU"}
                                            autoComplete="off"
                                            checked={this.props.document.tipoContraente === "GIU"}
                                            onChange={(e) => this.inputChangeHandler({
                                                target: {
                                                    value: "GIU",
                                                    id: "tipoContraente",
                                                }
                                            })} />
                                        <span key={"span1GIU2"} className="custom-control-indicator"></span>
                                        <span key={"span2GIU2"} className="custom-control-description">{i18n('ARM_CORE_PRODUCT.ANAGRAFICA.GIU', 'Giuridica')} </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col col-sm-9 col-md-9 col-lg-9">
                                <agui.ASelectV4
                                    id="documentType"
                                    onChange={this.inputChangeHandler}
                                    value={this.props.document ? this.props.document.documentType : null}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO.TIPO_DOCUMENTO', 'Tipo documento')}
                                    items={domain('AI_PRINT_DOCUMENT_TYPE')}
                                    valueKey="valCampo"
                                    labelKey="desDom"
                                    validation={this.state.validation}
                                />
                            </div>
                            <div className="col col-sm-3 col-md-3 col-lg-3">
                                {/* <agui.ASelectV4
                                    id="ordVis"
                                    onChange={this.inputChangeHandler}
                                    value={this.props.document.ordVis}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.ORDINE_VIS', 'Ord. visibilità')}
                                    items={this.state.ordersList}
                                    info={i18n('ARM_CORE_PRODUCT.SHARED.ORDINE_VIS', 'Ord. visibilità')}
                                    valueKey="value"
                                    labelKey="value"
                                    validation={this.state.validation}
                                />
                                 */}
                                    <agui.ATextInputV4 
                            id="ordVis"
                            required
                            onChange={this.inputChangeHandler}
                            value={parseInt(this.props.document.ordVis)}//+ 10                           
                            label={i18n('ARM_CORE_PRODUCT.SHARED.ORDINE_VIS', 'Ordine visibilità')}

                            info={i18n('ARM_CORE_PRODUCT.SHARED.NUMERO_INTERO', 'Solo numero intero')}
                            type="number"
                            validation={this.state.validation}
                        />
                            </div>
                        </div>
                        {this.props.document.documentType === "CLIENTE" && this.state.questionariSelezionabili &&
                            <div className="row mt-1">
                                <div className="col col-sm-12 col-md-12 col-lg-12">
                                    <agui.ASelectV4
                                        id="codQuestionario"
                                        onChange={this.inputChangeHandler}
                                        value={this.props.document ? this.props.document.codQuestionario : null}
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO.NOME_QUESTIONARIO', 'Nome questionario')}
                                        items={this.state.questionariSelezionabili}
                                        valueKey="valore"
                                        labelKey="valore"
                                        validation={this.state.validation}
                                    />
                                </div>
                            </div>
                        }
                        {/* } */}

                        {/* <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ASelectV4
                                    id="ordVis"
                                    onChange={this.inputChangeHandler}
                                    value={this.props.document.ordVis}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.ORDINE_VIS', 'Ordine visibilità')}
                                    items={this.state.ordersList}
                                    valueKey="value"
                                    labelKey="value"
                                    validation={this.state.validation}
                                />
                            </div>
                        </div> */}
                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                     testoButtonCancel = {i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}
                        confirmOnClick={this.salvaDocumentPrint} onClose={this.props.showConfirmPanel}>
                    </agui.ConfirmModalOkCancelV4.Footer>
                </agui.ConfirmModalOkCancelV4>
                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    deleteOnClick={this.deleteProdottoDocument}
                    onClose={this.showConfirmDelete} />
            </div>
        );
    }
};

function mapStateToProps(state) {
    return {
        prodotto: state.prodotto.detailsProdotto
    }
}

export default connect(mapStateToProps)(ProdottoDocumentPrint);
